// extracted by mini-css-extract-plugin
export default {"indicator-positive":"Indicator_indicator-positive__xxP5v","indicator-negative":"Indicator_indicator-negative__ziPpb"};